import styled, { css } from 'styled-components';
import { lighten } from 'polished';

import theme from '../../../styles/theme';

export const Container = styled.label`
  text-align: left;
  font: 300 15px Calibri;
  letter-spacing: 0.52px;

  opacity: 1;

  ${({ display }) =>
    display
      ? css`
          display: ${display};
        `
      : ``};

  ${({ margin }) =>
    margin
      ? css`
          margin: ${margin}px;
        `
      : `margin: 5px`};

  ${({ marginRight }) =>
    marginRight
      ? css`
          margin-right: ${marginRight}px;
        `
      : ``};

  ${({ maxHeight }) =>
    maxHeight
      ? css`
          max-height: ${maxHeight};
        `
      : `max-height: 200px;`};

  ${({ marginLeft }) =>
    marginLeft
      ? css`
          margin-left: ${marginLeft};
        `
      : ``};

  ${({ marginTop }) =>
    marginTop
      ? css`
          margin-top: ${marginTop};
        `
      : ''}

  ${({ marginBottom }) =>
    marginBottom
      ? css`
          margin-bottom: ${marginBottom}px;
        `
      : ``};

  ${({ error }) =>
    error
      ? css`
          > p {
            color: ${theme.red};
          }
          > input {
            background-color: ${lighten(0.46, theme.redLight)};
            border: 1px solid ${theme.redLight};
          }
          > input:hover:enabled {
            background-color: ${lighten(0.46, theme.redLight)};
            border: 1px solid ${theme.redLight};
          }
        `
      : ``};
`;

export const ErrorMessage = styled.span`
  color: ${theme.redLight};
  font: 13px Calibri Regular;
  padding-top: 8px;
`;
